export default "__VITE_ASSET__DXliEptB__"